import React, { useEffect, useState } from "react";
import { ApiRequestPost } from "../../../data/network/services/ApiRequestPost";
import { isPasswordValid } from "../../../utility/PasswordValidation";
import ResizeListener from "../../../utility/ResizeListener";
import { CustomButton } from "../../components/customButton/CustomButton";
import { CustomInput } from "../../components/customInput/CustomInput";
import CustomPasswordInput from "../../components/CustomPasswordInput";
import { NeokredNewLogo, NeokredTriangle } from "../../resources/assetsManager";
import { LOGIN_BG_COLOR, WHITE_COLOR } from "../../resources/colorsManager";
import { useSnackbar } from "notistack";
import { SUCCESS } from "../../resources/constantsManager";
import { useNavigate } from "react-router";

function NewPassword({ email }) {
  const { height, width } = ResizeListener();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [rememberMe, setRememberMe] = useState("checked");
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const onClickChangePassword = () => {
    setLoading(true);
    ApiRequestPost.updateForgotPassword(email, newPassword)
      .then((data) => {
        if (data.status === SUCCESS) {
          enqueueSnackbar(data.message, {
            variant: "success",
          });
          navigate("/login");
        } else {
          enqueueSnackbar(data.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    if (
      isPasswordValid(newPassword) &&
      confirmPassword &&
      confirmPassword === newPassword
    ) {
      setDisabled(false);
    } else setDisabled(true);
  }, [newPassword, confirmPassword]);

  return (
    <div
      style={{
        width,
        display: "flex",
        flexDirection: width > 650 ? "row" : "column",
        height: height,
      }}
    >
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: width > 650 ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: WHITE_COLOR,
        }}
      >
        <img
          src={NeokredNewLogo}
          style={{
            width: width * 0.35,
            minWidth: 150,
            maxWidth: 400,
          }}
        />
      </div>
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: LOGIN_BG_COLOR,
          flexDirection: "column",
          height,
        }}
      >
        <div
          style={{
            width: width > 650 ? "45%" : "70%",
            minWidth: width > 650 ? 300 : 250,
          }}
        >
          <p
            style={{
              fontWeight: "600",
              fontSize: 27,
              color: "#1A202C",
              margin: 0,
            }}
            className="roboto"
          >
            New Password
          </p>
          <p
            style={{
              fontSize: 15,
              color: "#2D3748",
              margin: 0,
              marginBottom: 20,
              lineHeight: "20px",
              marginTop: "5px",
            }}
            className="roboto"
          >
            Enter the new password and confirm it to change your password.
          </p>

          <div style={{ marginTop: "25px" }}>
            <p
              style={{ margin: 0, color: "#4A5568", fontSize: "14px" }}
              className="roboto"
            >
              New Password<span style={{ color: "#FC3629" }}>*</span>
            </p>
            {/* <CustomInput
           
              inputStyles={{
                width: "100%",
                border: "1px solid #E8E8E8",
                boxShadow: "none",
                backgroundColor: "white",
                height: "45px",
              }}
              validator="password"
              type="input"
              maxLength={16}
            /> */}

            <CustomPasswordInput
              value={newPassword}
              onChange={setNewPassword}
              placeholder="New Password"
              isError={(data) => console.log(data)}
            />
          </div>

          <div style={{ marginTop: "15px" }}>
            <p
              style={{ margin: 0, color: "#4A5568", fontSize: "14px" }}
              className="roboto"
            >
              Confirm New Password<span style={{ color: "#FC3629" }}>*</span>
            </p>
            <CustomPasswordInput
              value={confirmPassword}
              onChange={setConfirmPassword}
              placeholder="Confirm New Password"
              isError={(data) => console.log(data)}
            />
          </div>

          <CustomButton
            loading={loading}
            title="Continue"
            styles={{
              width: "100%",
              borderRadius: "4px",
              marginTop: 40,
              height: "50px",
            }}
            textStyle={{
              color: WHITE_COLOR,
              fontSize: 15,
              fontWeight: "500",
            }}
            onClick={() => {
              onClickChangePassword();
            }}
            disabled={disabled}
          />

          {/* <p
            style={{
              fontSize: 10,
              color: "rgba(174, 174, 178)",
              marginTop: 10,
            }}
          >
            <IoMdInformationCircleOutline />
            Password must contain 8- 16 Characters including 1 UpperCase
            Alphabet, 1 LowerCase Alphabet, 1 number & 1 Special Character
          </p> */}
        </div>
      </div>
    </div>
  );
}

export default NewPassword;
